import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Roles from './Roles';

const truncatedRoles = (experienceItems, maxItemsVisible) => {
  const itemsToTruncate = [...experienceItems];

  if (itemsToTruncate.length < maxItemsVisible) {
    return itemsToTruncate;
  }

  return itemsToTruncate.slice(0, maxItemsVisible);
};

const ShowMoreLink = styled.a`
  padding-top: 0;
  padding-left: 0;
  text-decoration: underline;
  font-weight: 700;
  cursor: pointer;
  color: ${props => props.theme.colors.weployBlue};
`;

const TruncatedRoles = (props) => {
  const { roles, maxItemsVisible } = props;

  const truncatedExperience = truncatedRoles(roles, maxItemsVisible);
  const propsWithTruncatedItems = {
    ...props,
    roles: truncatedExperience,
  };
  const remainingItems = roles.length - truncatedExperience.length;

  return (
    <Fragment>
      <Roles {...propsWithTruncatedItems} />
      { remainingItems > 0 &&
        <ShowMoreLink
          onClick={props.onShowMoreRolesClick}
        >
          {`${remainingItems} more`}
        </ShowMoreLink>
      }
    </Fragment>
  );
};

TruncatedRoles.propTypes = {
  onShowMoreRolesClick: PropTypes.func.isRequired,
  roles: PropTypes.arrayOf(PropTypes.object),
  maxItemsVisible: PropTypes.number,
};

TruncatedRoles.defaultProps = {
  roles: [],
  maxItemsVisible: null,
};

export default TruncatedRoles;
